import { useEffect, useState } from 'react';
import type { FormEvent } from 'react';
import { LuArrowLeft } from 'react-icons/lu';
import { NovaMark } from '../components/ui';
import { api, useMe } from '../lib/api';

export function Login() {
  const { me } = useMe();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (me?.user) location.replace('/');
  }, [me]);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api('/api/auth/login', { method: 'POST', body: { email, password } });
      location.assign('/');
    } catch (err) {
      setError((err as Error).message);
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <a className="auth-back" href="/">
        <LuArrowLeft /> Ana sayfa
      </a>
      <form className="card auth-card" onSubmit={submit}>
        <a className="brand" href="/">
          <NovaMark size={36} />
          <span className="brand-name">Nova Class</span>
        </a>
        <h1>Öğretmen girişi</h1>
        <p className="muted small">Derslerinizi açmak ve yönetmek için giriş yapın.</p>
        <label className="field">
          <span>E-posta</span>
          <input id="login-email" type="email" autoComplete="username" autoFocus required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="field">
          <span>Şifre</span>
          <input id="login-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {error && <p className="form-error">{error}</p>}
        <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={busy}>
          {busy ? 'Giriş yapılıyor…' : 'Giriş yap'}
        </button>
        <p className="muted small auth-note">
          <a href="/sifremi-unuttum">Şifremi unuttum</a>
        </p>
        <p className="muted small auth-note">
          Öğrenci misiniz? Hesap gerekmez; <a href="/#derse-katil">ders kodunuzla katılın</a>.
        </p>
        <p className="muted small auth-note">
          Hesabınız yok mu? <a href="/kayit">Hesap açın</a>.
        </p>
      </form>
    </div>
  );
}
